import { render } from "./employee-jolo.vue?vue&type=template&id=fc43243e"
import script from "./employee-jolo.vue?vue&type=script&lang=js"
export * from "./employee-jolo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__